import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import useSeo from "@/hooks/useSeo";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import PageHero from "@/components/feature/PageHero";
import { categories } from "@/mocks/doujinshi";

export default function Category() {
  useSeo({
    title: "同人志分类大全 | 百合·耽美·纯爱·热血等全品类导航",
    description:
      "同人志指南提供完整同人志分类：百合同人志、耽美同人志、纯爱治愈、热血冒险、奇幻仙侠、校园青春、悬疑烧脑与科幻机甲，清晰分类助你快速找到想看的同人作品。",
    path: "/category",
  });

  const [query, setQuery] = useState("");

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return categories;
    return categories.filter(
      (c) =>
        c.name.toLowerCase().includes(q) ||
        c.en.toLowerCase().includes(q) ||
        c.desc.toLowerCase().includes(q)
    );
  }, [query]);

  return (
    <div className="bg-background-50">
      <Navbar />
      <PageHero
        eyebrow="Category"
        title="同人志分类大全"
        desc="按题材划分的清晰分类体系，从百合、耽美到热血、仙侠，无论偏好何种风格，都能快速定位到你感兴趣的同人作品方向。"
        crumbs={[{ label: "同人志分类" }]}
      />

      <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-16">
        <div className="mx-auto flex max-w-md items-center gap-2 rounded-full border border-background-300 bg-background-50 px-4 py-2.5">
          <i className="ri-search-line text-lg text-secondary-500"></i>
          <input
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="搜索分类，如：百合、悬疑…"
            className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-secondary-400"
          />
          {query && (
            <button type="button" onClick={() => setQuery("")} className="text-secondary-500 hover:text-foreground-900" aria-label="清空搜索">
              <i className="ri-close-circle-fill"></i>
            </button>
          )}
        </div>
        <p className="mt-3 text-xs text-secondary-500">
          共 {filtered.length} 个分类{query ? `（筛选结果）` : ""}
        </p>

        <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {filtered.map((c) => (
            <article key={c.id} className="group overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-shadow hover:shadow-md">
              <div className="relative h-44 w-full overflow-hidden">
                <img src={c.image} alt={`${c.name}同人志分类封面`} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                <div className="absolute inset-x-0 bottom-0 flex items-end justify-between p-4">
                  <div>
                    <h2 className="font-heading text-xl font-bold text-background-50">{c.name}</h2>
                    <p className="text-xs text-background-100/80">{c.en}</p>
                  </div>
                  <span className="rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-white">{c.count} 部</span>
                </div>
              </div>
              <div className="p-5">
                <p className="text-sm leading-relaxed text-foreground-600">{c.desc}</p>
                <div className="mt-4 flex items-center justify-between">
                  <span className={`rounded-full px-3 py-1 text-xs ${c.hot ? "bg-primary-100 text-primary-700" : "bg-secondary-100 text-secondary-800"}`}>
                    {c.hot ? "🔥 热门分类" : "精选分类"}
                  </span>
                  <Link to="/popular" className="inline-flex items-center gap-1 text-sm font-medium text-primary-700 hover:text-primary-800">
                    查看代表作品 <i className="ri-arrow-right-line"></i>
                  </Link>
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
}